import axios from "axios";
import { type EmailSetting } from "features/Accounts/types";

const getUrl = (accountId: number) => `/api/accounts/${accountId}/threat-defence/smtp-settings`;

/* istanbul ignore next */
export default {
  getSmtpSettings: async (accountId: number): Promise<EmailSetting> => {
    const { data } = await axios.get(getUrl(accountId));
    return data;
  },
  createSmtpSettings: async (accountId: number, settings: EmailSetting): Promise<EmailSetting> => {
    const { data } = await axios.post(getUrl(accountId), settings);
    return data;
  },
  updateSmtpSettings: async (accountId: number, settings: EmailSetting): Promise<EmailSetting> => {
    const url = `${getUrl(accountId)}/${settings.id}`;
    const { data } = await axios.put(url, settings);
    return data;
  },
  deleteSmtpSettings: async (accountId: number): Promise<void> => {
    await axios.delete(getUrl(accountId));
  },
  getSender: async (accountId: number): Promise<any> => {
    const { data } = await axios.get(`${getUrl(accountId)}/sender`);
    return data;
  },
};
